import * as React from 'react';

import { Button } from '@mq/aurora-components/dist/button';

import * as styles from './video-card.css';

export interface IVideoCardProps {
  leftImage?: string;
}

export class VideoCard extends React.PureComponent<IVideoCardProps, {}> {
  handleMarqueeRoute = () => {
    window.location.href = 'https://marquee.gs.com/';
  };

  handleVideoContactRoute = () => {
    const mailTo: string = 'gs-marquee-sales@gs.com';
    const subject: string = 'Interested in learning more about Marquee';
    const body: string = 'I am interested in learning more about Marquee.';

    window.location.href = `mailto:${mailTo}?subject=${subject}&body=${body}`;
  };

  render() {
    return (
      <div className={styles.videoCard} style={{ padding: '0px', maxWidth: '704px' }}>
        <h1>Welcome to Marquee</h1>
        <p>Marquee is Goldman Sachs' digital storefront for institutional clients.</p>
        <p>
          David Solomon, Chairman and CEO of Goldman Sachs, introduces how Marquee delivers our risk
          management capabilities, application programming interfaces (APIs) and product ecosystem
          directly to you.
        </p>

        <video
          controls={true}
          controlsList={'nodownload'}
          src={'https://cdn.marquee.gs.com/videos/marquee-overview-4000k.mp4'}
          poster={'https://cdn.marquee.gs.com/images/MQVID_Poster.png'}
        />

        <div className={styles.videoCardSectionBottom}>
          <Button
            onClick={this.handleMarqueeRoute}
            size="large"
            type="primary"
            style={{ maxWidth: '250px', width: '100%' }}
          >
            Continue to Marquee
          </Button>
        </div>
        <a>
          <p className={styles.videoCardContact} onClick={this.handleVideoContactRoute}>
            Request Access to Marquee
          </p>
        </a>
      </div>
    );
  }
}
